if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this._swiperHover = null;
      this._observer = null;

      this.handlers = {
        mouseEnter: this._handleMouseEnter.bind(this),
        mouseLeave: this._handleMouseLeave.bind(this),
        swatchEnter: this._swatchEnter.bind(this),
        swatchLeave: this._swatchLeave.bind(this),
      };
    }

    connectedCallback() {
      this.addEventListener('mouseenter', this.handlers.mouseEnter);
      this.addEventListener('mouseleave', this.handlers.mouseLeave);
      document.addEventListener('swatchEnter', this.handlers.swatchEnter);
      document.addEventListener('swatchLeave', this.handlers.swatchLeave);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.handlers.mouseEnter);
      this.removeEventListener('mouseleave', this.handlers.mouseLeave);
      document.removeEventListener('swatchEnter', this.handlers.swatchEnter);
      document.removeEventListener('swatchLeave', this.handlers.swatchLeave);

      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _handleMouseEnter(event) {
      if (!event.target.closest('super-swatch-display')) {
        const itemHandle = this._getHoverHandle(this);
        this._initHoverSwiper(itemHandle);
      } else {
        this._destroySwiper();
      }
    }

    _handleMouseLeave() {
      this._destroySwiper();
    }

    _swatchEnter() {
      requestAnimationFrame(() => {
        this.classList.add('swatch-active');
      });
      this._destroySwiper();
    }

    _swatchLeave(event) {
      if (this.dataset.handle.includes(event.detail.source) && !this._swiperHover) {
        requestAnimationFrame(() => {
          this.classList.remove('swatch-active');
        });
        this._initHoverSwiper(`.product-images[data-handle="-${event.detail.source}"]`);
      }
    }

    _initHoverSwiper(handle) {
      if (this._swiperHover) return;

      const slideTemplate = this.querySelector('.product-images-slide');
      if (!slideTemplate) return;

      const hoverImage = this.querySelector('.image .hover-images');
      if (!hoverImage) return;

      // If product-images already exists, init swiper directly
      if (hoverImage.querySelector('.product-images')) {
        this._initSwiperInstance(handle);
        return;
      }

      // Otherwise, clone template first (in memory, no reflow yet)
      const cloneTemplate = slideTemplate.content.cloneNode(true);
      hoverImage.appendChild(cloneTemplate);

      // Use MutationObserver instead of setInterval to detect when DOM is ready
      this._observer = new MutationObserver((mutations, obs) => {
        const element = this.querySelector('.product-images');
        if (element) {
          this._initSwiperInstance(handle);
          obs.disconnect();
          this._observer = null;
        }
      });

      this._observer.observe(hoverImage, { childList: true, subtree: true });
    }

    _initSwiperInstance(handle) {
      this._swiperHover = new Swiper(handle, {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        // ⚡ Removed heavy observers (they cause layout thrashing)
        // observer: true,
        // observeParents: true,
        // resizeObserver: true,
      });
    }

    _destroySwiper() {
      if (this._swiperHover && typeof this._swiperHover.destroy === 'function') {
        this._swiperHover.destroy(true, true);
        this._swiperHover = null;
      }
    }

    _getHoverHandle(image) {
      return `.product-images[data-handle="${image.dataset.handle}"]`;
    }
  }

  customElements.define('product-card', ProductCard);
}